// extracted by mini-css-extract-plugin
export default {"overlay":"kA-z","bodyOpen":"lA-z","content":"mA-z","header":"nA-z","close":"oA-z","closeNoHeading":"pA-z"};